let AbstractGeocoder = require('./../abstractGeocoder');
let YandexGeocodingItem = require('./yandexGeocodingItem');
let axios = require('axios');

class YandexGeocoder extends AbstractGeocoder {
   constructor(params) {
      super(params);
      this.params = params;

      const defaultToken = "59d20e520a69de37518b4569";
      this.token = params.token || defaultToken;
      this.url = params.url || "https://geocode-maps.yandex.ru/1.x/?geocode";
   }

   async geocode(location) {
      let self = this;
      let result = (await axios(self.url + "=" + location + "&format=json")).data;
      let items = result.response.GeoObjectCollection.featureMember.map((item) => {
         return new YandexGeocodingItem(item.GeoObject);
      });
      return items;
   }

   async reverseGeocode(coordinates) {
      let self = this;
      let results = (await axios(self.url + "=" + coordinates.join(",") + "&format=json")).data;
      return results;
   }
}

module.exports = YandexGeocoder;